import XLSX from 'xlsx';
import { httpGet, httpPut, httpDelete } from '../../Util/http';
import { routeActions } from 'redux-simple-router';
import { addAlert } from '../../MsgNotify/msgNotifyActions';
import { calcCompletedHours, renderOverAllocation, calcOverAllocation, sumTotalHrs } from '../../Util/overAllocation';
import { dates, dateMonthAndYear, getWeeknumber } from '../../Util/dateTime';


export const FETCH_WEEKLY_REQUEST = 'FETCH_WEEKLY_REQUEST';
export const fetchWeeklyRequest = () => {
    return {
        type: FETCH_WEEKLY_REQUEST
    }
}

export const FETCH_WEEKLY_SUCCESS = 'FETCH_WEEKLY_SUCCESS';
export const fetchWeeklySuccess = (json, date, projectNumber) => {
    return {
        type: FETCH_WEEKLY_SUCCESS,
        rootActivities: json.weekOverview.rootActivities,
        activities: json.weekOverview.activities,
        weekNo: json.weekOverview.weekNo,
        date,
        projectNumber
    }
}

function calcSumsFooter(rootActivities) {
    var estimated = 0;
    var transferredTotal = 0;
    var weeklySum = 0;
    var mon = 0;
    var tue = 0;
    var wed = 0;
    var thu = 0;
    var fri = 0;
    var sat = 0;
    var sun = 0;
    rootActivities.forEach(a => {
        estimated += a.estimated;
        transferredTotal += a.transferredTotal;
        weeklySum += a.weeklyTotal;
        mon += a.mon;
        tue += a.tue;
        wed += a.wed;
        thu += a.thu;
        fri += a.fri;
        sat += a.sat;
        sun += a.sun;
    });
    return {
        estimated,
        transferredTotal,
        weeklySum,
        mon, tue, wed, thu, fri, sat, sun
    };
};

function createActivityRow(activity) {
    let row = [];
    row.push(activity.name);
    row.push(Math.round(activity.estimated * 10) / 10);
    row.push(activity.transferredTotal);
    row.push(activity.sumTotal);
    row.push(Math.floor(activity.percentComplete));

    var completedHrs = calcCompletedHours(activity.estimated, activity.percentComplete);
    row.push(completedHrs);

    var overAllocation = calcOverAllocation(completedHrs, activity.sumTotal);
    row.push(overAllocation);
    return row;
}

function calcPercentComplete(arr) {
    let result = (arr.reduce((a, b) => a + b, 0)) / arr.length;
    return isNaN(result) ? 0 : result;
};

export const exportToExcel = () => {
    return (dispatch, getState) => {
        let red = getState().weeklyOverviewReducer
        if (red.percentChanged) {
            return alert('Oversigten har ændret sig. Opdater siden og prøv at hente excel igen')
        }
        let footerPercentCompleteArr = []
        let data = [["Aktivitet", "Sum Timer (Estimeret)", "Overført Forbrug", "Sum Forbrug", "Procent udført", "Udført timer", "+/- Forbrug timer"], []]
        red.rootActivities.forEach(element => {
            let row = createActivityRow(element);
            data.push(row)
            footerPercentCompleteArr.push(element.percentComplete)


            element.activityIds.forEach(a => {
                let activity = red.activities[a]
                let row2 = createActivityRow(activity);
                data.push(row2)
            })

            element.subActivities.forEach(element1 => {

                let row3 = createActivityRow(element1);
                data.push(row3)

                element1.activityIds.forEach(a2 => {
                    let activity2 = red.activities[a2]
                    let row4 = createActivityRow(activity2);
                    data.push(row4)
                })

            })

            data.push([])
        });

        let footerSum = calcSumsFooter(red.rootActivities)

        //calc footer
        var footerPercentComplete = Math.floor(calcPercentComplete(footerPercentCompleteArr));
        var sumTotal = sumTotalHrs(footerSum.transferredTotal, footerSum.weeklySum);

        let row5 = createActivityRow({
            name: 'Ialt',
            estimated: footerSum.estimated,
            transferredTotal: footerSum.transferredTotal,
            sumTotal: sumTotal,
            percentComplete: footerPercentComplete,
        });
        data.push(row5)
        data.push(["Ialt-rækken opdateres ikke ved ændringer i excel arket"])

        let title = getState().weeklyOverviewReducer.projectNumber
        let date = new Date(getState().weeklyOverviewReducer.currDate)
        var daysToSubtract = date.getDay() > 0 ? 1 : -6; //sunday is the exception
        date.setDate(date.getDate() - (date.getDay() - daysToSubtract));
        var weekNumber = getWeeknumber(date);
        var monthAndYear = dateMonthAndYear(date);

        let text = `${title}uge${weekNumber}${monthAndYear}`

        /* convert state to workbook */
        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, text);
        /* generate XLSX file */
        const wbout = XLSX.write(wb, { type: "array", bookType: "xlsx" });
        /* send to client */
        let blo = new Blob([wbout], { type: "application/octet-stream" })
        let url = window.URL.createObjectURL(blo);
        var a = document.createElement("a");
        a.href = url;
        a.download = `Projektoversigt for ${title} uge ${weekNumber} ${monthAndYear}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);

        if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blo, `Projektoversigt for ${title} uge ${weekNumber} ${monthAndYear}.xlsx`);
        }
    }
}

export const fetchWeekly = (projectNumber, date) => {
    /*HACK to remove double quotes from json date
    see: http://weblog.west-wind.com/posts/2014/Jan/06/JavaScript-JSON-Date-Parsing-and-real-Dates*/
    date = JSON.parse(JSON.stringify(date));
    var _url = process.env.REACT_APP_webApiEndPoint + "api/project/" + projectNumber + "/weekly?Date=" + date
    return dispatch => {
        dispatch(fetchWeeklyRequest());
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => dispatch(fetchWeeklySuccess(json, date, projectNumber)))
            .catch(() => {
                //TODO pushpath to previous kanban overview
                dispatch(routeActions.push('/'));
                dispatch(addAlert("Kunne ikke hente data"))
            })
    };
}

export const SUBMIT_PERCENT_REQUEST = 'SUBMIT_PERCENT_REQUEST'
export const submitPercentRequest = (activityId, percent) => {
    return {
        type: SUBMIT_PERCENT_REQUEST,
        activityId: activityId,
        percent: percent
    }
}

export const SUBMIT_PERCENT_SUCCESS = 'SUBMIT_PERCENT_SUCCESS'
export const submitPercentSuccess = () => {
    return {
        type: SUBMIT_PERCENT_SUCCESS
    }
}

export const SUBMIT_PERCENT_FAILURE = 'SUBMIT_PERCENT_FAILURE'
export const submitPercentFailure = (activityId, percent) => {
    return {
        type: SUBMIT_PERCENT_FAILURE,
        activityId: activityId,
        percent: percent
    }
}

export const DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS'
export const deleteActivitySuccess = (rootIndex, index, id) => {
    return {
        type: DELETE_ACTIVITY_SUCCESS,
        rootIndex: rootIndex,
        index: index,
        id: id
    }
}

export const DELETE_ACTIVITY_SUCCESS_SUB = 'DELETE_ACTIVITY_SUCCESS_SUB'
export const deleteActivitySuccessSub = (rootIndex, index, id) => {
    return {
        type: DELETE_ACTIVITY_SUCCESS_SUB,
        rootIndex: rootIndex,
        index: index,
        id: id
    }
}


export const DELETE_ACTIVITY_SUCCESS_THIRD = 'DELETE_ACTIVITY_SUCCESS_THIRD'
export const deleteActivitySuccessThird = (rootIndex, index, id, thirdIndex) => {
    return {
        type: DELETE_ACTIVITY_SUCCESS_THIRD,
        rootIndex: rootIndex,
        index: index,
        id: id,
        thirdIndex: thirdIndex
    }
}

export const submitPercent = (date, activityId, percent, oldPercent) => {
    return (dispatch) => {
        dispatch(submitPercentRequest(activityId, percent))
        /*HACK to remove double quotes from json date
        see: http://weblog.west-wind.com/posts/2014/Jan/06/JavaScript-JSON-Date-Parsing-and-real-Dates*/
        date = JSON.parse(JSON.stringify(date));
        const _url = process.env.REACT_APP_webApiEndPoint + "api/weekly/activity/progress?Date=" + date;
        return httpPut(_url, [{ ActivityId: activityId, Progress: percent }])
            .then(() => {
                dispatch(submitPercentSuccess());
            })
            .catch((e) => {
                dispatch(submitPercentFailure(activityId, oldPercent))
                dispatch(addAlert(e.message))
            })
    }
}



export function deleteActivity(rootIndex, index, id, thirdIndex, second) {
    return (dispatch) => {
        const _url = process.env.REACT_APP_webApiEndPoint + "api/activity/" + id
        return httpDelete(_url)
            .then(() => {
                if (second === true)
                    dispatch(deleteActivitySuccessSub(rootIndex, index, id))
                else if (thirdIndex === undefined)
                    dispatch(deleteActivitySuccess(rootIndex, index, id));
                else
                    dispatch(deleteActivitySuccessThird(rootIndex, index, id, thirdIndex))
            })
            .catch((e) => {
                dispatch(addAlert(e.message))
            })
    }
}



// WEBPACK FOOTER //
// ./src/App/Project/WeekOverview/actions.js